import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

function Header() {
    const [isSticky, setIsSticky] = useState(false);
    const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Check if the page is scrolled down more than 50px
            setIsSticky(window.scrollY > 50);
        };

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleOffcanvasToggle = () => {
        setIsOffcanvasOpen(!isOffcanvasOpen);
    };

    const handleOffcanvasClose = () => {
        setIsOffcanvasOpen(false);
    };

    return (
        <>
            {/* Start Navbar Area */}
            <nav
                className={`navbar main-navbar navbar-expand-lg bg-color-ffffff ${
                    isSticky ? "sticky" : ""
                }`}
                id="navbar"
            >
                <div className="container-fluid side-padding position-relative">
                    <NavLink className="navbar-brand logo-brand p-0" to="/home">
                        <img src="assets/images/logo.svg" alt="image" />
                    </NavLink>
                    <NavLink
                        className="navbar-toggler"
                        role="button"
                        aria-controls="navbarOffcanvas"
                        onClick={handleOffcanvasToggle}
                    >
                        <span className="burger-menu">
                            <span className="top-bar" />
                            <span className="middle-bar" />
                            <span className="bottom-bar" />
                        </span>
                    </NavLink>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mx-auto">
                            <li className="nav-item dropdown">
                                <NavLink to="/money-transfer" className="nav-link">
                                    Money Transfer
                                </NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <NavLink to="/offer" className="nav-link">
                                Raffle Offer
                                </NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <NavLink to="/help" className="nav-link">
                                    Help
                                </NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <NavLink to="/contact-us" className="nav-link">
                                    Contact Us
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="others-options">
                        <ul className="d-flex align-items-center ps-0 mb-0 list-unstyled">
                            
                            <li>
                                <NavLink to="/download-ifepay-app"  className="default-btn">
                                    Download Now    
                                </NavLink>
                            </li>
                        </ul>
                        {/* <ul className="d-flex align-items-center ps-0 mb-0 list-unstyled">
                            <li>
                                <NavLink to="https://ifepay.co.uk/app/sign-up" target="_blank" className="search-btn login">
                                    Signup
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="https://ifepay.co.uk/app/app-login.html" target="_blank" className="default-btn">
                                    Login
                                </NavLink>
                            </li>
                        </ul> */}
                    </div>
                </div>
            </nav>
            {/* End Navbar Area */}
            {/* Start Mobile Navbar Area */}
            <div
                className={`mobile-navbar offcanvas offcanvas-end border-0 ${
                    isOffcanvasOpen ? "show" : ""
                }`}
                data-bs-backdrop="static"
                tabIndex={-1}
                id="navbarOffcanvas"
            >
                <div className="offcanvas-header">
                    <NavLink to="/" className="logo d-inline-block">
                        <img src="assets/images/logo.svg" alt="logo" />
                    </NavLink>
                    <button
                        type="button"
                        className="close-btn bg-transparent position-relative lh-1 p-0 border-0"
                        aria-label="close"
                        onClick={handleOffcanvasClose}
                    >
                        <i className="ri-close-fill" />
                    </button>
                </div>
                <div className="offcanvas-body">
                    <ul className="mobile-menu">
                        <li className="mobile-menu-list without-icon">
                            <NavLink to="/money-transfer" className="nav-link">
                                Money Transfer
                            </NavLink>
                        </li>
                        <li className="mobile-menu-list without-icon">
                            <NavLink to="/help" className="nav-link">
                                Help
                            </NavLink>
                        </li>
                        <li className="mobile-menu-list without-icon">
                            <NavLink to="/contact-us" className="nav-link">
                                Contact Us
                            </NavLink>
                        </li>
                    </ul>
                    {/* Others options */}
                    <div className="others-options">
                        <ul className="d-flex align-items-center ps-0 mb-0 list-unstyled">
                         
                            <li>
                                <NavLink to="/download-ifepay-app" target="_blank" className="default-btn">
                                    Download Now
                                </NavLink>
                            </li>
                        </ul>
                        {/* <ul className="d-flex align-items-center ps-0 mb-0 list-unstyled">
                            <li>
                                <NavLink to="https://ifepay.co.uk/app/sign-up" target="_blank" className="search-btn login">
                                    Signup
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="https://ifepay.co.uk/app/app-login.html" target="_blank" className="default-btn">
                                    Login
                                </NavLink>
                            </li>
                        </ul> */}
                    </div>
                </div>
            </div>
            {/* End Mobile Navbar Area */}
        </>
    );
}

export default Header;
